import axios from '../../utils/axios'
import store from '../store'
import { logApiTime, validateInternationalAddressCombined } from '../../utils/helpers'

export const SET_SCANNED_PACKAGE_LOADER = 'SET_SCANNED_PACKAGE_LOADER'
export const POST_SCANNED_PACKAGE_SUCCESS = 'POST_SCANNED_PACKAGE_SUCCESS'
export const POST_SCANNED_PACKAGE_ERROR = 'POST_SCANNED_PACKAGE_ERROR'
export const FC_SCAN_PACKAGE_ERROR = 'FC_SCAN_PACKAGE_ERROR'
export const POST_SCANNED_PACKAGE_WARNING = 'POST_SCANNED_PACKAGE_WARNING'
export const POST_INTERNATIONAL_ADDRESS_WARNING = 'POST_INTERNATIONAL_ADDRESS_WARNING'
export const SET_SCANNED_PACKAGE = 'SET_SCANNED_PACKAGE'
export const GET_SCANNED_PACKAGE_HISTORY = 'GET_SCANNED_PACKAGE_HISTORY'
export const GET_SCANNED_PACKAGE_HISTORY_ERROR = 'GET_SCANNED_PACKAGE_HISTORY_ERROR'
export const SET_UNSCAN_MODE = 'SET_UNSCAN_MODE'
export const POST_UNSCAN_PACKAGE_SUCCESS = 'POST_UNSCAN_PACKAGE_SUCCESS'
export const POST_UNSCAN_PACKAGE_ERROR = 'POST_UNSCAN_PACKAGE_ERROR'
export const UPDATE_POSTAGE_SUCCESS = 'UPDATE_POSTAGE_SUCCESS'
export const UPDATE_POSTAGE_ERROR = 'UPDATE_POSTAGE_ERROR'
export const VALIDATE_PACKAGE_ERROR = 'VALIDATE_PACKAGE_ERROR'
export const GET_USER_DAILY_SCAN_COUNT = 'GET_USER_DAILY_SCAN_COUNT'
export const GET_USER_DAILY_SCAN_COUNT_ERROR = 'GET_USER_DAILY_SCAN_COUNT_ERROR'
export const SET_PENDING_TEST_PACKAGE_WARNING = 'SET_PENDING_TEST_PACKAGE_WARNING'
export const DISMISS_INTERNATIONAL_WARNING = 'DISMISS_INTERNATIONAL_WARNING'

// Warning timeout constants
const TEST_PACKAGE_WARNING_TIMEOUT = 800 // 800ms

// Helper function to clear warning after timeout
const clearWarningAfterTimeout = (dispatch, warningAction, timeout) => {
  setTimeout(() => {
    dispatch(warningAction)
  }, timeout)
}

// export const ValidateScanPackage = (id, location, isPresortRate) => {
//   const config = store.getState().global.config
//   const axiosConfig = {
//     method: 'post',
//     baseURL: config.baseURL,
//     url: '/package/valid',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: {
//       PackageId: id
//     }
//   }
//   return (dispatch) => {
//     dispatch(SetLoading(true))
//     return axios(axiosConfig)
//       .then(() => {
//         dispatch(PostScannedPackage(id, location, isPresortRate))
//       })
//       .catch(error => {
//         console.log(`ValidateScanPackage error is: ${error.message}`)
//         dispatch(ValidateScanPackageError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
//         dispatch(SetLoading(false))
//       })
//       .finally(() => {
//         setTimeout(() => {
//           dispatch(ValidateScanPackageError(''))
//         }, 800)
//       })
//   }
// }

export const ScanPackage = (id) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'put',
    baseURL: config.FC_BaseUrl,
    url: `/${id}/package-scanned`,
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return (dispatch) => {
    return axios(axiosConfig)
      .then((response) => {
      })
      .catch(error => {
        dispatch(FCScanPackageError(`Final scan failed - ${error?.response?.data?.Message ? error?.response?.data?.Message : error.message}`))
        console.log(`Final Scan error is: ${error.message}`)
      })
      .finally(() => {
        dispatch(SetLoading(false))
      })
  }
}

export const ValidateScanPackage = (id, location, isPresortRate) => {
  const startTime = new Date().getTime()
  let endTime = 0
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/scan',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      PackageId: id,
      FacilityId: location.name,
      IsPresortPostage: (isPresortRate === 'true')
    }
  }
  return (dispatch) => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then((response) => {
        endTime = new Date().getTime()

        const scannedPackage = response.data.ScannedPackage

        // Check for international address validation first - only if MailToState and MailToCity exist
        const isInternational = (scannedPackage?.MailToState && scannedPackage?.MailToCity)
          ? validateInternationalAddressCombined(
            scannedPackage.MailToState,
            scannedPackage.MailToCity,
            scannedPackage.MailToCountry,
            scannedPackage.Client
          )
          : false
        const isTestPackage = scannedPackage.IsTest

        // Handle warnings in priority order: International first, then Test
        if (isInternational) {
          dispatch(PostInternationalAddressWarning('This package is considered to be an International Package. Please set aside.'))

          if (isTestPackage) {
            // Set pending test package warning to be shown after international warning is dismissed
            dispatch(SetPendingTestPackageWarning(true))
          }
        } else if (isTestPackage) {
          // Only test package warning
          dispatch(PostScannedPackageWarning(isTestPackage))
          clearWarningAfterTimeout(dispatch, PostScannedPackageWarning(false), TEST_PACKAGE_WARNING_TIMEOUT)
        }

        dispatch(PostScannedPackageSuccess(true))

        // Prepare package data for table
        scannedPackage.id = scannedPackage.PackageId
        scannedPackage.ScanDate = new Date(scannedPackage.ScanDate)
        scannedPackage.ActualPostage = Number(scannedPackage.ActualPostage).toFixed(3)

        dispatch(SetScannedPackage(scannedPackage))
        dispatch(ScanPackage(id))
      })
      .catch(error => {
        console.log(`PostScannedPackage error is: ${error.message}`)
        dispatch(PostScannedPackageError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetLoading(false))
        setTimeout(() => {
          dispatch(PostScannedPackageError(''))
          dispatch(PostScannedPackageSuccess(false))
        }, 800)
        if (endTime !== 0) {
          logApiTime(startTime, endTime)
        }
      })
  }
}

export const GetScannedPackageHistory = () => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'get',
    baseURL: config.baseURL,
    url: '/package/scanhistory',
    headers: {
      'Content-Type': 'application/json'
    }
  }

  return (dispatch) => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then((response) => {
        response.data.ScannedPackages.map((r) => {
          // DataGrid requires a unique id be passed to it
          r.id = r.PackageId
          // needs to be in date format in order to be sorted properly within the table
          r.ScanDate = new Date(r.ScanDate)
          r.ActualPostage = Number(r.ActualPostage).toFixed(3)
        })
        dispatch(SetScannedHistory(response.data.ScannedPackages))
      })
      .catch(error => {
        console.log(`GetScannedPackageHistory error is: ${error.message}`)
        dispatch(GetScannedPackageHistoryError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetLoading(false))
      })
  }
}

export const PostUnscanPackage = (id, location, isPresortRate) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/unscan',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      PackageId: id,
      FacilityId: location.name,
      IsPresortPostage: (isPresortRate === 'true')
    }
  }

  return (dispatch) => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then(() => {
        dispatch(PostUnscanPackageSuccess(true))
      })
      .catch(error => {
        console.log(`PostUnscanPackage error is: ${error.message}`)
        dispatch(PostUnscanPackageError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
      .finally(() => {
        dispatch(SetLoading(false))
      })
  }
}

export const UpdatePostage = (id, postageValue) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    baseURL: config.baseURL,
    url: '/package/postage',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      PackageId: id,
      UpdatedPostage: postageValue
    }
  }

  return (dispatch) => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then(() => {
        dispatch(UpatePostageSuccess(true))
        // go through scanHistory and update postage
        dispatch(GetScannedPackageHistory()) // GetScannedPackageHistory will set loading to false
      })
      .catch(error => {
        console.log(`UpdatePostage error is: ${error.message}`)
        dispatch(SetLoading(false))
        dispatch(UpatePostageError(error?.response?.data?.Message ? error?.response?.data?.Message : error.message))
      })
  }
}

export const GetUserDailyScanCount = () => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'get',
    baseURL: config.baseURL,
    url: '/package/usersDailyScanCount',
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return (dispatch) => {
    return axios(axiosConfig)
      .then((response) => {
        dispatch(SetDailyPackageCount(response.data?.PackageCounts))
      })
      .catch(error => {
        console.log(`GetUserDailyScanCount error is: ${error.message}`)
        dispatch(SetDailyPackageCountError(error?.response?.data?.Message
          ? `There was an issue obtaining your daily count. The cause was: ${error?.response?.data?.Message}`
          : `There was an issue obtaining your daily count. The cause was: ${error.message}`))
      })
      .finally(() => {
        setTimeout(() => {
          dispatch(SetDailyPackageCountError(''))
        }, 1000)
      })
  }
}

export const SetUnscanMode = (isUnscan) => {
  return {
    type: SET_UNSCAN_MODE,
    unscanMode: isUnscan
  }
}

export const SetLoading = (isLoading) => {
  return {
    type: SET_SCANNED_PACKAGE_LOADER,
    loading: isLoading
  }
}

export const PostScannedPackageSuccess = (isSuccess) => {
  return {
    type: POST_SCANNED_PACKAGE_SUCCESS,
    scanSuccess: isSuccess
  }
}

export const PostScannedPackageError = (error) => {
  return {
    type: POST_SCANNED_PACKAGE_ERROR,
    error
  }
}

export const FCScanPackageError = (error) => {
  return {
    type: FC_SCAN_PACKAGE_ERROR,
    error
  }
}

export const PostScannedPackageWarning = (isTest) => {
  return {
    type: POST_SCANNED_PACKAGE_WARNING,
    isTest
  }
}

export const PostInternationalAddressWarning = (message) => {
  return {
    type: POST_INTERNATIONAL_ADDRESS_WARNING,
    message
  }
}

export const SetScannedPackage = (scannedPackage) => {
  return {
    type: SET_SCANNED_PACKAGE,
    scannedPackage
  }
}

export const SetScannedHistory = (scanHistory) => {
  return {
    type: GET_SCANNED_PACKAGE_HISTORY,
    scanHistory
  }
}

export const GetScannedPackageHistoryError = (error) => {
  return {
    type: GET_SCANNED_PACKAGE_HISTORY_ERROR,
    error
  }
}

export const PostUnscanPackageSuccess = (isSuccess) => {
  return {
    type: POST_UNSCAN_PACKAGE_SUCCESS,
    unscanSuccess: isSuccess
  }
}

export const PostUnscanPackageError = (error) => {
  return {
    type: POST_UNSCAN_PACKAGE_ERROR,
    error
  }
}

export const UpatePostageSuccess = (isSuccess) => {
  return {
    type: UPDATE_POSTAGE_SUCCESS,
    updatePostageSuccess: isSuccess
  }
}

export const UpatePostageError = (error) => {
  return {
    type: UPDATE_POSTAGE_ERROR,
    error
  }
}

export const ValidateScanPackageError = (error) => {
  return {
    type: VALIDATE_PACKAGE_ERROR,
    error
  }
}

export const SetDailyPackageCount = (count) => {
  return {
    type: GET_USER_DAILY_SCAN_COUNT,
    count
  }
}

export const SetDailyPackageCountError = (error) => {
  return {
    type: GET_USER_DAILY_SCAN_COUNT_ERROR,
    error
  }
}

export const SetPendingTestPackageWarning = (isPending) => {
  return {
    type: SET_PENDING_TEST_PACKAGE_WARNING,
    isPending
  }
}

export const DismissInternationalWarning = () => {
  return (dispatch, getState) => {
    // Clear the international warning
    dispatch(PostInternationalAddressWarning(''))

    // Check if there's a pending test package warning
    const state = getState()
    if (state.finalScan.pendingTestPackageWarning) {
      // Clear the pending state
      dispatch(SetPendingTestPackageWarning(false))
      // Show the test package warning
      dispatch(PostScannedPackageWarning(true))
      // Set timeout to clear test package warning
      clearWarningAfterTimeout(dispatch, PostScannedPackageWarning(false), TEST_PACKAGE_WARNING_TIMEOUT)
    }
  }
}
